import { render, staticRenderFns } from "./userBieyangai.vue?vue&type=template&id=a873538a&scoped=true&"
import script from "./userBieyangai.vue?vue&type=script&lang=js&"
export * from "./userBieyangai.vue?vue&type=script&lang=js&"
import style0 from "./userBieyangai.vue?vue&type=style&index=0&id=a873538a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a873538a",
  null
  
)

export default component.exports